module.exports = __webpack_public_path__ + "img/worksbot_img19112534.53e398fd.jpg";